module.exports = __webpack_public_path__ + "img/notify3.086f8735.png";